// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6402) return "static/chunks/6402-7689ac31053d25cc.js";
	if (chunkId === 8900) return "static/chunks/8900-f594654eb51202ef.js";
	if (chunkId === 3246) return "static/chunks/3246-c8e58478e23bd2e5.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2669":"c132bf7d","5194":"badf541d"}[chunkId] || chunkId) + "." + {"1247":"db7412ab05e6128c","1704":"b334d5b566361945","2669":"84cb6da48dc7f118","4065":"c62f61a74410b2e7","5194":"25cc162cc753a650","6055":"80c7151c7268e02e","6740":"2bc9299beaf82c87"}[chunkId] + ".js";
};